<template>
  <div>
    <div class="main-block">

        <div class="container">
            <div class="row">
                <div class="col-lg-12">

                  <div class="bck-index bck-articles">
                      <h3 class="title sr-only"><span>推薦歌曲 - 歌詞與video</span></h3>
                      <div class="row">
                        <div class="col-md-10 offset-md-1 col-12">
                          <article class="article-editor">
                            <h3 class="text-primary text-center">會員隱私權保護政策</h3>
                            <br /><br />
                            <p>「桅頂上」網站非常重視您的隱私權。請您閱讀以下有關隱私權保護政策的更多內容。</p>

                            <p>本政策內容主要包括：「桅頂上」如何處理蒐集或收到的個人資料 (包括您過去使用 「桅頂上」產品及服務相關的資料）。個人資料是指得以識別您的身分且未公開的資料，如姓名、地址、電子郵件地址或電話號碼。</p>

                            <p>本隱私權保護政策只適用於 「桅頂上」。本政策不適用於非 「桅頂上」所有或控制的公司，也不適用於非 「桅頂上」僱用或管理之人。</p>

                            <p>說明如下</p>

                            <p>在您註冊 「桅頂上」帳號、使用 「桅頂上」產品或服務、瀏覽 「桅頂上」網頁或某些合作夥伴的網頁，以及參加宣傳活動或贈獎遊戲時，「桅頂上」會蒐集您的個人資料。「桅頂上」也可能將商業夥伴或其他企業所提供的關於您的資訊與 「桅頂上」所擁有的您的個人資料相結合。</p>

                            <p>在您註冊 「桅頂上」帳號並登入我們的服務後，我們即可辨別您的身分。 您得自由選擇是否提供個人資料給我們，但若特定資料欄位係屬必填欄位時，您若不提供該等資料，將無法使用相關的「桅頂上」產品及服務。</p>

                            <p>「桅頂上」將自動接收並記錄您電腦和瀏覽器上的資料，包括 IP位址、「桅頂上」cookie的資料、軟體和硬體屬性以及您瀏覽的網頁紀錄。 在您使用「桅頂上」產品及服務期間，「桅頂上」得於全球地區將資料用作以下用途：客製化廣告及您看到的網頁內容、滿足您對產品和服務的要求、改進我們的服務、聯絡您、進行研究，以及提供內部及外部客戶不載有個人資料之市場分析或業務報告。&nbsp;</p>

                            <p>除非是為了向您提供您所要求的產品或服務、獲得您的授權，或有以下情形，否則 「桅頂上」不會向任何其他人士或非關係企業提供您的個人資料，或與之分享：</p>

                            <ol>
                              <li>
                                <p>
                                  我們向已簽署保密協議書之代表 「桅頂上」執行業務或與我們共事的值得信賴的合作夥伴提供這些資料。這些公司可能會將您的個人資料用於協助 「桅頂上」，就我們和行銷夥伴所提供產品及服務的事宜，與您進行溝通。但這些公司無獨立權利分享這些資料。
                                </p>
                                <ul>
                                	<li>「桅頂上」會根據您的個人資料向您展示精準式行銷廣告：您瀏覽精準式行銷廣告或與廣告發生互動時，「桅頂上」不會向廣告主提供您的任何個人資料。然而，一旦瀏覽廣告或與廣告發生互動，即表示您同意廣告主假設您對廣告主的廣告有興趣，而向您展示精準式行銷廣告。</li>
                                	<li>「桅頂上」的廣告主：婚禮服務提供者 (如婚禮顧問、婚禮攝影、婚宴場地、喜餅/禮盒、海外婚禮&nbsp;/&nbsp;蜜月旅遊、婚戒/飾品等)，和非婚禮服務提供公司 (如產品、金融、通路、軟體公司等)。</li>
                                	<li>Cookie的設定和存取：「桅頂上」會在您的電腦上設定並存取與產品及服務有關的cookie，並允許某些 「桅頂上」網頁上刊登廣告的廣告主在您的電腦上設定並存取 cookie。其他公司將根據其自訂的隱私權政策使用其cookie，並非依據本政策。<br />
                                	&nbsp;</li>
                                </ul>
                              </li>
                              <li>
                                <p>我們認為為了調查和防止非法活動、涉嫌詐欺、對人身安全有潛在威脅的狀況、對「桅頂上」服務條款的違反，或為了對上述情形採取應對措施，或法律另有規定，而有必要分享您的個人資料時。</p>
                              </li>
                              <li>
                                <p>如果「桅頂上」全部或部分業務被其他公司收購或合併，我們會將您的個人資料移轉給該公司。如果發生這種情況，「桅頂上」會在您的個人資料被移轉且將適用不同的隱私權政策前通知您。</p>
                              </li>
                            </ol>

                            <p>您可隨時查詢、閱覽、複製及修改個人 「桅頂上」帳號資料，包括行銷偏好設定 。</p>

                            <p>「桅頂上」會不定時在行銷偏好設定頁面上增加新類別的行銷訊息。瀏覽此頁面的使用者可選擇退出接收新類別的行銷訊息，或按照所收訊息中的指示取消訂閱這些訊息。 我們保有權利向您傳送 「桅頂上」服務相關的特定訊息 (如服務公告、管理訊息)，這些訊息被視為您「桅頂上」帳號的一部分，您無法選擇退出接收。</p>

                            <p>如果您要刪除您的「桅頂上」帳號，請與我們聯繫。<br />
                            我們已採取符合法規要求的實體、電子和程序防護措施，以保護您個人資料的安全。&nbsp;「桅頂上」將不定時修訂本隱私權保護政策。當我們在個人資料的處理上有重大變更時，會將通知傳送到您在 「桅頂上」帳號中指定的主要電子郵件地址，或在我們的網站上張貼告示。</p>

                            <p>生效日期：2017年9月01日</p>
                          </article>
                        </div>
                      </div>
                  </div>

                </div>
              </div>
          </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'privacy',
  data () {
    return {
      msg: ''
    }
  }
}
</script>


// WEBPACK FOOTER //
// Privacy.vue?2b8a6d46